import { FC } from "react";
import { SanityVideoFile } from "../../graphql-types";
import Video from "./Video";

export interface VideoFileBlockProps {
  value: SanityVideoFile;
}

const VideoFileBlock: FC<VideoFileBlockProps> = ({ value }) => {
  return <Video title={value.title} url={value.asset.url} />;
};

export default VideoFileBlock;
